import { stepUpTest } from "@/api/test";
import { useMutation } from "@tanstack/react-query";

export const useStepUpTest = () => {
  return useMutation({
    mutationFn: stepUpTest,
  });
};
